import { Button, Col, Form, InputNumber, message, Modal, Row, Spin } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import { RedeemCodeTemplate } from 'src/types/redeemCode';

interface Props {
  redeemCodeTemplate: RedeemCodeTemplate;
  form: WrappedFormUtils;
}
interface State {
  isCreateRedeemCodeConfirmVisible: boolean;
  redeemCodeCount: number;
}

const CREATE_CODES_MUTATION = gql`
  mutation createRedeemCodes($templateId: Int!, $count: Int!) {
    createRedeemCodes(templateId: $templateId, count: $count) {
      id
    }
  }
`;
export class CreateRedeemCode extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isCreateRedeemCodeConfirmVisible: false,
      redeemCodeCount: 0,
    };
  }

  showCreateRedeemCodeModal = () => {
    this.setState({ isCreateRedeemCodeConfirmVisible: true });
  };

  hideCreateRedeemCodeModal = () => {
    this.setState({ isCreateRedeemCodeConfirmVisible: false });
  };

  render() {
    const { channel, desc, id } = this.props.redeemCodeTemplate;
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Button type="primary" size="small" onClick={this.showCreateRedeemCodeModal}>
          生成兑换码
        </Button>
        <Mutation
          mutation={CREATE_CODES_MUTATION}
          variables={{
            templateId: id,
            count: this.state.redeemCodeCount,
          }}
        >
          {(createCodes, { loading }) => {
            return (
              <Modal
                title="生成兑换码"
                visible={this.state.isCreateRedeemCodeConfirmVisible}
                onOk={async () => {
                  this.props.form.validateFields((err, values) => {
                    if (err) {
                      message.error(err);
                      return;
                    }
                    if (!values.redeemCodeCount) {
                      message.warning('请输入兑换码数量！');
                      return;
                    }
                    if (loading) {
                      return;
                    }
                    this.setState(
                      {
                        redeemCodeCount: values.redeemCodeCount,
                        isCreateRedeemCodeConfirmVisible: false,
                      },
                      async () => {
                        try {
                          await createCodes();
                          message.success('生成兑换码成功');
                        } catch (e) {
                          message.error('生成失败');
                        }
                      },
                    );
                  });
                }}
                onCancel={this.hideCreateRedeemCodeModal}
              >
                <div>
                  <Row style={{ marginBottom: 10 }}>
                    <Col span={20}>
                      <span>渠道模板：</span>
                      <span>
                        {channel} --- {desc}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={20}>
                      <Form>
                        <Form.Item label={'生成数量：'}>
                          {getFieldDecorator('redeemCodeCount')(<InputNumber />)}
                        </Form.Item>
                      </Form>
                    </Col>
                    <Col>
                      <span>{loading && <Spin />}</span>
                    </Col>
                  </Row>
                </div>
              </Modal>
            );
          }}
        </Mutation>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/redeemCode/CreateRedeemCode.tsx